import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import SidebarLayout from "../componenet/sidebarlayout";

const ProtectedRoute = ({ Component }) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <SidebarLayout>
        <Component />
      </SidebarLayout>
    </>
  );
};

export default ProtectedRoute;
